import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { notify } from '../features/feedback/notify';

/**
 * A page's notice, as a toast.
 *
 * The warehouse screens compose their own sentence for every outcome ("3 un de
 * POL-001 sacadas de A-01-01", "Orden #1042 cancelada · 6 un liberadas") and
 * show the server's refusal inside the dialog that caused it; that is why
 * their thunks sit in `EXPLICIT_NOTIFY_THUNKS`. This hook is where those
 * sentences go on screen: the same `{type, message}` the pages always built,
 * placed on the platform's toast stack under the page's handle, so a test can
 * find it and a message outlives the page that raised it.
 *
 * @param {string} testId - The toast's handle, e.g. `'orders-notice'`.
 * @returns {(notice: {type: 'success'|'error'|'info'|'warning', message: string}|null) => void}
 */
export const useNotice = (testId) => {
  const dispatch = useDispatch();
  return useCallback(
    (notice) => {
      if (!notice?.message) return;
      const show = notify[notice.type] || notify.success;
      dispatch(show(notice.message, { testId }));
    },
    [dispatch, testId]
  );
};
